export default "__VITE_ASSET__DddFVCUQ__"